export const Events = {
  MAP_SHOW_TRAYECTORY: 'map-show-trayectory',
  MAP_CLOSE_POPUP: 'map-close-popup'
}
